const pricing = {
    mbMax: 5,
    minutesElapsed: 60
};

export default pricing